"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _qs = _interopRequireDefault(require("qs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function setQueryStringValue(value, isSinglePage) {
  if (window) {
    var query = _qs.default.parse(((0, _get.default)(window, 'location.search') || '').replace('?', '')) || {};
    (0, _merge.default)(query, value);
    if (isSinglePage && (0, _get.default)(window, 'history.pushState')) {
      window.history.pushState({}, '', "".concat(window.location.pathname, "?").concat(_qs.default.stringify(query)));
    } else if (window.location) {
      window.location.search = "?".concat(_qs.default.stringify(query));
    }
  }
}
var _default = exports.default = setQueryStringValue;